import { useMemo } from 'react';

import { themeObjectToString, themeStringToObject } from '@atlaskit/tokens';

import {
	EMBEDDED_THEME_STATE,
	PARENT_PRODUCT_QUERY_PARAM,
	PARENT_PRODUCT_SMART_LINK,
} from '../database-params';

export const useInitialUrl = ({
	version,
	isSmartLinkEmbed,
	initialTheme,
}: {
	version?: string;
	isSmartLinkEmbed?: boolean;
	initialTheme?: string;
}) => {
	return useMemo(() => {
		const url = new URL(
			`/databases${process.env.NODE_ENV === 'development' ? '-dev' : ''}/standalone`,
			window.location.origin,
		);

		if (version) {
			url.searchParams.set('bifrost-override', version);
		}

		if (isSmartLinkEmbed) {
			url.searchParams.set(PARENT_PRODUCT_QUERY_PARAM, PARENT_PRODUCT_SMART_LINK);
		}

		if (initialTheme) {
			const themeObject = themeStringToObject(initialTheme);
			url.pathname = `${url.pathname}/${themeObject.colorMode === 'dark' ? 'index-dark.html' : 'index.html'}`;
			url.searchParams.set(
				EMBEDDED_THEME_STATE,
				encodeURIComponent(themeObjectToString(themeObject)),
			);
		}

		const finalUrlParts = [url.pathname];
		if (Array.from(url.searchParams).length > 0) {
			finalUrlParts.push(url.searchParams.toString());
		}

		return finalUrlParts.join('?');
	}, [version, isSmartLinkEmbed, initialTheme]);
};
